
import Vue from "vue";
import MainLayout from "@/layout/MainLayout.vue";
import axios from "axios";

export default Vue.extend({
  name: "App",
  components: { MainLayout },

  data: function () {
    return {
      tabs: [
        {
          name: this.$t("molecule.title"),
          link: "/molecule",
          icon: "mdi-molecule",
        },
        {
          name: this.$t("family.title"),
          link: "/family",
          icon: "mdi-family-tree",
        },
        {
          name: this.$t("source.title"),
          link: "/source",
          icon: "mdi-book-open",
        },
        {
          name: this.$t("synergy.title"),
          link: "/synergy",
          icon: "mdi-vector-circle",
        },
      ],
      overlay: false,
    };
  },
  mounted() {
    axios.interceptors.request.use(
      (config) => {
        this.overlay = true;
        return config;
      },
      (error) => {
        this.overlay = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.overlay = false;
        return response;
      },
      (error) => {
        this.overlay = false;
        return Promise.reject(error);
      }
    );
  },
});
